import React from 'react';
import { Animate } from "react-simple-animate";

import NoFaves from "../../Components/NoFaves";
import WatchSection from "./SliderSections/WatchSection";
import ReadSection from "./SliderSections/ReadSection";
import LearnSection from "./SliderSections/LearnSection";

const FavouritesContent = ({ noFaves }) => (
    <Animate play start={{opacity: 0}} end={{opacity: 1}} duration={0.7}>
        {noFaves && <NoFaves />}
        <WatchSection />
        <ReadSection />
        <LearnSection />
    </Animate>
);

export default FavouritesContent;